export default __webpack_public_path__ + "static/media/cancel_app.bc156d5d.svg";